import React from 'react';
import { withState } from 'recompose';
import EstimateBoxTooltip from '../tooltips/EstimateBoxTooltip';
import GaugeBar from './GaugeBar';
import TEST_IDS from '../../utils/_tests/testIds.constants';
import { GaugeBarWrapper, GaugueValueLabel } from './estimate-gauge-bar.styles';
import { APPCUES_ID } from './estimate-gauge-bar.constants';

interface EstimateGaugeBarProps {
    estimate?: number;
    percentage?: number;
    isNewOverview?: boolean;
    gaugeColor?: string;
    isHover?: boolean;
    setHover?: (value: boolean) => void;
}

export const EstimateGaugeBar = ({
    estimate,
    isHover,
    percentage,
    setHover,
    isNewOverview,
    gaugeColor,
}: EstimateGaugeBarProps) => (
    <GaugeBarWrapper
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        data-appcues-id={APPCUES_ID.GAUGE_BAR_WRAPPER}
    >
        {isHover && !isNewOverview && (
            <EstimateBoxTooltip
                percentage={percentage}
                estimateValue={estimate.toFixed(2) || '-'}
            />
        )}
        <GaugueValueLabel
            data-testid={TEST_IDS.OVERVIEW_GAUGE.GAUGE_AVERAGE}
            marginLeft={percentage > 80 ? percentage - 10 : percentage}
        >
            {percentage}%
        </GaugueValueLabel>
        <GaugeBar
            color={gaugeColor}
            value={percentage}
        />
    </GaugeBarWrapper>
);

EstimateGaugeBar.defaultProps = {
    gaugeColor: '#FFFFFF',
};

export default withState('isHover', 'setHover', false)(EstimateGaugeBar);
